import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import orderBy from 'lodash/orderBy';

import getSort, { sortByName } from 'utils/sorts';
import EMOJI_MAP from 'constants/emojis';
import theme from 'styles/theme';
import ModalWrapper from './ModalWrapper';
import Currency from 'components/Currency';

const Details = styled.div`
  margin-top: 25px;

  .Details__title {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 8px;
  }

  .Details__debts {
  }
`;

const DebtItem = styled.div`
  user-select: none;
  color: ${theme.font_primary};
  text-shadow: 0 1px 1px ${theme.B600};

  .Debt__title {
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    padding: 8px 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    transition: padding 300ms, border-color 300ms;

    &:hover {
      border-left-color: ${theme.A500};
      border-right-color: ${theme.A500};
      padding: 8px;
    }

    &-left {
      font-size: 18px;
      margin-right: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-right {
      margin-left: auto;
      white-space: nowrap;
    }
  }

  .Debt__interest {
    display: inline-flex;
    margin-right: 8px;
    font-size: 80%;
    color: ${theme.font_secondary};
  }
`;

const getItemStyle = draggableStyle => ({
  ...draggableStyle,
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const { sortDirection, sortMethod } = getSort('paydownOrder');

class DialogModal extends PureComponent {
  state = {
    debts: orderBy(this.props.details.debts, [sortMethod, sortByName], [sortDirection, 'asc']),
  };

  onClose = () => {
    this.props.onClose(this.state.debts);
  };

  onDragEnd = result => {
    if (!result.destination) return;
    this.setState({
      debts: reorder(this.state.debts, result.source.index, result.destination.index),
    });
  };

  render() {
    const { debts } = this.state;
    const { details, ...props } = this.props;

    return (
      <ModalWrapper
        {...props}
        width={500}
        locked={true}
        title="Re-Order Debts"
        closeText="Confirm Order"
        cancelText="Nevermind, Cancel"
        onClose={this.onClose}
      >
        <p>You can use this area to sort the order of your debts when using the "Custom Order" sorting option.</p>
        <p>
          Typically you would use this for tweaking debts to be a different order from the standard Avalance/Snowball
          methods.
        </p>
        <Details>
          <div className="Details__title">Debt Order (Drag to Reorder)</div>
          <div className="Details__debts">
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div ref={provided.innerRef}>
                    {debts.map((debt, index) => (
                      <Draggable key={debt.id} draggableId={debt.id} index={index}>
                        {(provided, snapshot) => (
                          <div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(provided.draggableProps.style)}
                            >
                              <DebtItem>
                                <div className="Debt__title">
                                  <div className="Debt__title-left">
                                    <span className="Debt__interest">{index + 1})</span>
                                    {debt.type && (
                                      <span className="Debt__emoji" role="img" aria-label={debt.type}>
                                        {EMOJI_MAP[debt.type]}
                                      </span>
                                    )}
                                    {debt.name}
                                  </div>
                                  <div className="Debt__title-right">
                                    {debt.interest !== undefined ? (
                                      <span class="Debt__interest">{`${debt.interest}%`}</span>
                                    ) : (
                                      ''
                                    )}
                                    <Currency quantity={debt.current} />
                                  </div>
                                </div>
                              </DebtItem>
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </Details>
      </ModalWrapper>
    );
  }
}

export default DialogModal;



// WEBPACK FOOTER //
// ./src/components/Modals/DebtOrderModal.js